import {useState, useEffect} from 'react';
import Header from './components/Header';
import SearchForm from './components/SearchForm';
import ProfileSection from './components/ProfileSection';
import NetworkPage from './pages/NetworkPage';
import {useTheme} from './components/ThemeProvider';
import type {ProfileSummary, FriendData} from './types/steam';

function App() {
    const {theme} = useTheme();
    const [status, setStatus] = useState<{ message: string; kind: 'info' | 'warn' | 'error' }>({
        message: '—',
        kind: 'info',
    });
    const [profileSummary, setProfileSummary] = useState<ProfileSummary | null>(null);
    const [friends, setFriends] = useState<FriendData[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    // Check if we're on the network page
    const isNetworkPage = window.location.pathname.startsWith('/network/');

    useEffect(() => {
        // Apply theme to document element
        if (theme === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [theme]);

    const handleProfileLoadWithUrl = (summary: ProfileSummary) => {
        setProfileSummary(summary);

        // Update URL with resolved Steam ID
        try {
            const newPath = '/' + encodeURIComponent(summary.id64);
            if (window.location.pathname !== newPath) {
                window.history.pushState({steamId: summary.id64}, '', newPath);
            }
        } catch (e) {
            console.warn('Could not update URL:', e);
        }
    };

    // If we're on the network page, render that instead
    if (isNetworkPage) {
        return <NetworkPage />;
    }

    return (
        <div className="page-container">
            <div className="content-wrapper">
                <Header/>

                <SearchForm
                    status={status}
                    onStatusChange={setStatus}
                    onProfileLoad={handleProfileLoadWithUrl}
                    onFriendsLoad={(friendsData) => {
                        setFriends(friendsData);
                        setIsLoading(false);
                    }}
                    onLoadingStart={() => {
                        setIsLoading(true);
                    }}
                />

                {(profileSummary || isLoading) && (
                    <ProfileSection
                        summary={profileSummary}
                        friends={friends}
                        isLoading={isLoading}
                    />
                )}
            </div>
        </div>
    );
}

export default App;
